import { render } from "./JapchaeTteokbokkiBody.vue?vue&type=template&id=527ffc26&scoped=true"
import script from "./JapchaeTteokbokkiBody.vue?vue&type=script&lang=js"
export * from "./JapchaeTteokbokkiBody.vue?vue&type=script&lang=js"

import "./JapchaeTteokbokkiBody.vue?vue&type=style&index=0&id=527ffc26&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-527ffc26"]])

export default __exports__